import apiCredentials from "./api-credentials";
import attachment from "./attachment";
import brands from "./brand";
import brokers from "./brokers";
import call from "./call";
import categoryWeight from "./category-weight";
import commissionStatements from "./commission-statements";
import connectors from "./connectors";
import connectorCalls from "./connector-calls";
import contacts from "./contacts";
import contracts from "./contracts";
import costs from "./costs";
import coverageCategories from "./coverage-categories";
import coverages from "./coverages";
import coverageBenefits from "./coverages-benefits";
import discountCodes from "./discount-codes";
import distributions from "./distributions";
import documentTemplates from "./document-templates";
import * as email from "./email";
import events from "./events";
import flows from "./flows";
import geoZones from "./geo-zones";
import insurancePlans from "./insurance-plans";
import links from "./link";
import notes from "./notes";
import notifications from "./notifications";
import offers from "./offers";
import organizations from "./organizations";
import organizationParameters from "./organization-parameters";
import pricers from "./pricers";
import processes from "./processes";
import productRangeAdvisorCodes from "./product-range-advisor-codes";
import projects from "./projects";
import qualifications from "./qualifications";
import qualifiers from "./qualifiers";
import quotes from "./quotes";
import referentials from "./referentials";
import reminders from "./reminders";
import security from "./security";
import sources from "./sources";
import stores from "./stores";
import subscriptions from "./subscription";
import tasks from "./task";
import tracers from "./tracers";
import users from "./users";
import workflows from "./workflows";
import screens from "./screens";
import ageBrackets from "./age-brackets";
import zones from "./zones";
import regimes from "./regimes";
import insurancePlanCoverages from "./insurance-plan-coverages";
import coverageMappings from "./coverage-mappings";
import fieldRegistry from "./field-registry";
import projectRuns from "./project-runs";

const mutations = {
  ...contracts,
  ...organizations,
  ...organizationParameters,
  ...users,
  ...projects,
  ...sources,
  ...flows,
  ...processes,
  ...tracers,
  ...contacts,
  ...notes,
  ...insurancePlans,
  ...coverages,
  ...coverageBenefits,
  ...costs,
  ...qualifiers,
  ...qualifications,
  ...reminders,
  ...quotes,
  ...subscriptions,
  ...attachment,
  ...brokers,
  ...call,
  ...workflows,
  ...pricers,
  ...commissionStatements,
  ...categoryWeight,
  ...coverageCategories,
  ...distributions,
  ...discountCodes,
  ...offers,
  ...links,
  ...brands,
  ...stores,
  ...events,
  ...tasks,
  ...geoZones,
  ...notifications,
  ...referentials,
  ...email,
  ...productRangeAdvisorCodes,
  ...security,
  ...documentTemplates,
  ...screens,
  ...ageBrackets,
  ...zones,
  ...regimes,
  ...insurancePlanCoverages,
  ...coverageMappings,
  ...fieldRegistry,
  ...projectRuns,
  ...connectors,
  ...apiCredentials,
  ...connectorCalls,
};

export default mutations;
